import PurchaseFlowStepper, { PurchaseFlowStep } from './PurchaseFlowStepper';

const PurchaseFlowMobileRow = ({
  current,
  steps,
  links,
}: {
  current: PurchaseFlowStep;
  steps?: PurchaseFlowStep[];
  links?: Partial<Record<PurchaseFlowStep, string>>;
}) => (
  <div className="w-full bg-gray-300 lg:hidden">
    <div className="reebelo-container py-3">
      <PurchaseFlowStepper current={current} steps={steps} links={links} fill />
    </div>
  </div>
);

export default PurchaseFlowMobileRow;
